"use client";
import { useTranslations } from "next-intl";
import { Link, useRouter } from "@/navigation";

export default function ShopByCate() {
	const t = useTranslations("");

	return (
		<div>
			<div className="container mt-[80px] flex flex-col items-center justify-center gap-[20px] max-md:mt-[80px] max-md:gap-[15px] max-sm:mt-[50px] max-sm:gap-[10px]">
				<div className="flex flex-col items-center gap-2">
					<h2 className="font-queens group relative mb-4 text-center text-[32px] font-medium md:text-[42px] lg:text-[52px]">
						{t("home.t1")}

						<span className="absolute bottom-0 left-0 h-0.5 w-0 bg-black transition-all duration-300 group-hover:w-full"></span>
					</h2>
				</div>
				<div className="flex gap-[20px]">
					<div className="flex flex-col gap-[20px]  text-center max-md:!hidden">
						<Link className="group relative overflow-hidden !rounded-xl" href={"/support#user-manuals"}>
							<img
								src="/image/home/h1.webp"
								className="h-[260px] w-[870px] rounded-xl object-cover transition-all duration-700 group-hover:scale-110 group-hover:blur-sm"
								alt="User Manuals"
							/>
							<p className="font-bold、text-white absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 text-[26px] font-bold text-white">
								{t("home.t2")}
							</p>
						</Link>
						<Link className="group relative  overflow-hidden !rounded-xl" href={"/contact-us"}>
							<img
								src="/image/home/h2.webp"
								className="h-[260px] w-[870px] rounded-xl object-cover transition-all duration-700 group-hover:scale-110 group-hover:blur-sm"
								alt="Contact Us"
							/>
							<p className="font-bold、text-white absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2   text-[26px] font-bold text-white">
								{t("home.t3")}
							</p>
						</Link>
					</div>
					<Link className="group relative overflow-hidden  !rounded-xl max-md:!hidden" href={"/support"}>
						<img
							src="/image/home/h3.webp"
							className="h-[540px] w-[870px] rounded-xl object-cover transition-all duration-700 group-hover:scale-110 group-hover:blur-sm"
							alt="Support Centre"
						/>
						<p className="font-bold、text-white absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 text-[26px] font-bold text-white max-lg:text-[22px]">
							{t("home.t4")}
						</p>
					</Link>
				</div>
				{/* 移动端显示 */}
				<div className="hidden max-md:grid max-md:grid-cols-2 max-md:gap-[15px] max-sm:gap-[10px]">
					<Link className="group relative overflow-hidden !rounded-xl" href={"/support#user-manuals"}>
						<img
							src="/image/home/h1.webp"
							className="h-[160px] w-full rounded-xl object-cover transition-all duration-700 group-hover:scale-110 group-hover:blur-sm max-sm:h-[100px]"
							alt="Catalogue"
						/>
						<div className="absolute left-1/2 top-1/2 flex -translate-x-1/2 -translate-y-1/2 flex-col items-center justify-center">
							<p className="text-center text-[16px] font-semibold text-white max-sm:text-[14px]">
								{t("home.t2")}
							</p>
						</div>
					</Link>
					<Link className="group relative overflow-hidden !rounded-xl" href={"/contact-us"}>
						<img
							src="/image/home/h2.webp"
							className="h-[160px] w-full rounded-xl object-cover transition-all duration-700 group-hover:scale-110 group-hover:blur-sm max-sm:h-[100px]"
							alt="Catalogue"
						/>
						<div className="absolute left-1/2 top-1/2 flex -translate-x-1/2 -translate-y-1/2 flex-col items-center justify-center">
							<p className="text-center text-[16px] font-semibold text-white max-sm:text-[14px]">
								{t("home.t3")}
							</p>
						</div>
					</Link>
					<Link className="group relative overflow-hidden !rounded-xl" href={"/support"}>
						<img
							src="/image/home/h3.webp"
							className="h-[160px] w-full rounded-xl object-cover transition-all duration-700 group-hover:scale-110 group-hover:blur-sm max-sm:h-[100px]"
							alt="Catalogue"
						/>
						<div className="absolute left-1/2 top-1/2 flex -translate-x-1/2 -translate-y-1/2 flex-col items-center justify-center">
							<p className="text-center text-[16px] font-semibold text-white max-sm:text-[14px]">
								{t("home.t4")}
							</p>
						</div>
					</Link>
					<div className="group relative overflow-hidden !rounded-xl">
						<img
							src="/image/home/h4.webp"
							className="h-[160px] w-full rounded-xl object-cover transition-all duration-700 group-hover:scale-110 group-hover:blur-sm max-sm:h-[100px]"
							alt="Catalogue"
						/>
						<div className="absolute left-1/2 top-1/2 flex -translate-x-1/2 -translate-y-1/2 flex-col items-center justify-center gap-2">
							<p className="text-center text-[16px] font-semibold text-white max-sm:text-[14px]">
								{t("home.t5")}
							</p>
							<a href="/1.pdf" download>
								<button className="transition-bg h-[30px] w-[90px] rounded-lg  bg-main text-[12px] text-white  duration-300  hover:text-black max-sm:h-[26px] max-sm:w-[80px] max-sm:text-[10px]">
									{t("home.t6")}
								</button>
							</a>
						</div>
					</div>
				</div>
				{/* 分割 */}
				<div className="group relative w-full overflow-hidden !rounded-xl max-md:hidden">
					<img
						src="/image/home/h4.webp"
						className="h-[260px] w-full rounded-xl object-cover transition-all duration-700 group-hover:scale-110 group-hover:blur-sm"
						alt="Catalogue"
					/>
					<div className="font-bold、text-white absolute left-1/2 top-1/2 flex -translate-x-1/2  -translate-y-1/2 flex-col items-center justify-center gap-[20px] font-bold text-white">
						<p className="text-[26px]">{t("home.t5")}</p>
						<a href="/1.pdf" download>
							<button className="transition-bg h-[40px] w-[110px] rounded-lg  bg-main text-white duration-300  hover:text-black">
								{t("home.t6")}
							</button>
						</a>
					</div>
				</div>
			</div>
		</div>
	);
}
